import React from 'react';
import { ReactComponent as SearchIcon } from 'assets/icons/Search.svg';
import styles from './SearchCupsInput.module.scss';

const SearchCupsInput = (props: React.InputHTMLAttributes<HTMLInputElement>): JSX.Element => (
  <div className={styles.container}>
    <input type="text" {...props} />
    <SearchIcon />
  </div>
);
export default SearchCupsInput;
